<div class="flex gap-3 cursor-pointer max-[450px] flex-col">
  @for (item of nItems; track $index) {
  <div class="flex gap-3 w-full">
    <div
      class="max-w-[290px] bg-grey-skeleton animate-pulse h-[155px] max-sm:max-w-[190px] max-sm:h-[105px] max-[450px]:max-w-[unset] max-[450px]:h-[unset] max-[450px]:aspect-news w-full rounded-7 object-cover"
    ></div>

    <div class="flex flex-col gap-3 w-full">
      <div class="bg-grey-skeleton animate-pulse w-full h-[20px]"></div>
      <div class="bg-grey-skeleton animate-pulse w-[50%] h-[20px]"></div>

      <div class="bg-grey-skeleton animate-pulse w-full h-[10px]"></div>
      <div class="bg-grey-skeleton animate-pulse w-[30%] h-[10px]"></div>
    </div>
  </div>
  }
</div>
